import { findOrCreate, update, getProposal } from 'repositories/proposal.repository';

/**
 * Action types
 */
export const SELECT_PROPOSAL = 'SELECT_PROPOSAL';
export const UPDATED_PROPOSAL = 'UPDATED_PROPOSAL';
export const FINISHED_PROPOSAL = 'FINISHED_PROPOSAL';

/**
 * Action Creators
 */
const selectProposal = (proposal) => ({
  type: SELECT_PROPOSAL,
  payload: proposal,
});

const updatedProposal = (proposal) => ({
  type: UPDATED_PROPOSAL,
  payload: proposal,
});

const finishedProposal = () => ({
  type: FINISHED_PROPOSAL,
  payload: null,
});

/**
  * Método utilizado para criar uma nova proposta
  * Caso já exista uma mesma proposta com o CPF/E-mail
  * informado retorna a proposta anterior
  * @param {Attributes of affiliation} params
  */
export const createProposal = (params) => (dispatch) => findOrCreate(params)
  .then((res) => dispatch(selectProposal(res.data)));

export const updateProposal = (id, params) => (dispatch) => update(id, params)
  .then(() => dispatch(updatedProposal(params)));

export const finishProposal = () => (dispatch) => dispatch(finishedProposal());

export const findProposal = (uid) => async (dispatch) => {
  const { data } = await getProposal(uid);
  dispatch(selectProposal(data));
  return data;
};
